import Cookies from 'js-cookie'
import constants from '@constants'

const getCartId = (id?: string) => {
  const { SHOPIFY_CART_ID_COOKIE } = constants
  return id || Cookies.get(SHOPIFY_CART_ID_COOKIE)
}

export default getCartId
